import * as React from "react";
import { Card } from "antd";
import { PolicyTargetAgent } from "./agent";
import { PolicyTargetAuditContext } from "./auditctx";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { PolicyTargetCloudaccount } from "./cloudaccount";
import { PolicyTargetDomain } from "./domain";
import { PolicyTargetGroup } from "./group";
import { PolicyTargetGvc } from "./gvc";
import { PolicyTargetIdentity } from "./identity";
import { PolicyTargetImage } from "./image";
import { PolicyTargetIpSet } from "./ipset";
import { PolicyTargetLocation } from "./location";
import { PolicyTargetKubernetes } from "./mk8s";
import { PolicyTargetPolicy } from "./policy";
import { PolicyTargetQuota } from "./quota";
import { PolicyTargetSecret } from "./secret";
import { PolicyTargetServiceaccount } from "./serviceaccount";
import { PolicyTargetUser } from "./user";
import { PolicyTargetVolumeSet } from "./volumeset";
import { PolicyTargetWorkload } from "./workload";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";
import { pluralNameOfKind } from "../../../services/cpln";
import { useCpFormValue } from "../../gvc/testNewForm/utils";

interface Props {}
export const TargetItems: React.FC<Props> = ({}) => {
  const org = useAppSelector(selectOrg);

  const targetKind = useCpFormValue(`targetKind`);
  const targetAll = useCpFormValue(`targetAll`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>{pluralNameOfKind(targetKind)}</CardTitle>
          {targetKind === "org" ? (
            <div>Policy target is this org ({org}) itself.</div>
          ) : targetKind === "task" ? (
            <div>Policy target is all tasks in this org ({org}).</div>
          ) : targetAll ? (
            <div>Policy target is "all", no need to select items, all {targetKind} items of this org is targeted.</div>
          ) : (
            <>
              {/* // */}
              {targetKind === "agent" ? <PolicyTargetAgent /> : null}
              {targetKind === "auditctx" ? <PolicyTargetAuditContext /> : null}
              {targetKind === "cloudaccount" ? <PolicyTargetCloudaccount /> : null}
              {/* TODO fix why domain doesnt show detailed infos */}
              {targetKind === "domain" ? <PolicyTargetDomain /> : null}
              {targetKind === "group" ? <PolicyTargetGroup /> : null}
              {targetKind === "gvc" ? <PolicyTargetGvc /> : null}
              {targetKind === "identity" ? <PolicyTargetIdentity /> : null}
              {targetKind === "image" ? <PolicyTargetImage /> : null}
              {targetKind === "ipset" ? <PolicyTargetIpSet /> : null}
              {targetKind === "location" ? <PolicyTargetLocation /> : null}
              {targetKind === "mk8s" ? <PolicyTargetKubernetes /> : null}
              {targetKind === "policy" ? <PolicyTargetPolicy /> : null}
              {targetKind === "quota" ? <PolicyTargetQuota /> : null}
              {targetKind === "secret" ? <PolicyTargetSecret /> : null}
              {targetKind === "serviceaccount" ? <PolicyTargetServiceaccount /> : null}
              {targetKind === "user" ? <PolicyTargetUser /> : null}
              {targetKind === "volumeset" ? <PolicyTargetVolumeSet /> : null}
              {targetKind === "workload" ? <PolicyTargetWorkload /> : null}
            </>
          )}
        </Card>
      </div>
    </>
  );
};
